import { defineStore } from 'pinia'

import useActions from './actions'

import { type PaymentStateType } from './types'

export const usePaymentStore = defineStore('payment', () => {
  const state = reactive<PaymentStateType>({
    voucherByCode: {
      data: null,
      isLoading: false
    },
    vouchersPublic: {
      data: null,
      isLoading: false
    },
    transactions: {
      data: null,
      isLoading: false
    },
    transactionDetail: null
  })

  const actions = useActions({ state })

  return {
    state,
    ...actions
  }
})
